import { createComponentHealth } from '@apps/admin/common/ComponentHealth';

export const [wrapWithWeddingAlreadyExistsHealthProvider, useWeddingAlreadyExistsHealth] = createComponentHealth('CreateWedding | Wedding already exists');
